<div class="grid items-end lg:grid-cols-12">
  <div class="lg:col-span-4 xl:col-span-3">
    <app-public-product-search-panel
      (phraseChangeEvent)="handlePhraseChangeEvent($event)" />
  </div>

  <div class="lg:col-span-4 xl:col-span-6"></div>

  <div class="lg:col-span-4 xl:col-span-3">
    <app-public-product-sort-panel
      (sortTypeChange)="handleSortTypeChange($event)" />
  </div>
</div>

@if (products$ | async; as products) {
  <div class="grid gap-6 sm:grid-cols-3 lg:grid-cols-3 xl:grid-cols-4">
    @for (product of products; track product.id) {
      <app-public-products-for-sale-tile
        [imageAlt]="product.featuredFile.alt"
        [imageSrc]="product.featuredFile.url"
        [slug]="product.slug"
        [name]="product.name"
        [type]="product.type"
        [sales]="product.sales"
        class="px-4" />
    }
  </div>
} @else {
  <div class="flex min-h-72 w-full items-center justify-center">
    <app-spinner-filled />
  </div>
}
